import { Dispatch } from "redux";
import { SyncMap } from "twilio-sync";

import { SyncMapItemRemovedEvent, SyncMapItemUpdatedEvent } from "./syncListener.types";
import { updateSyncMapItemData } from "../genericActions";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const initSyncListeners = (map: SyncMap, conversationSid: string, dispatch: Dispatch) => {
    const itemUpdatedEvent = "itemUpdated";
    const itemRemovedEvent = "itemRemoved";

    map.removeAllListeners(itemUpdatedEvent);
    map.removeAllListeners(itemRemovedEvent);

    map.addListenerWithReplay(itemUpdatedEvent, ({ isLocal, item }: SyncMapItemUpdatedEvent) => {
        // Do nothing with local events
        if (isLocal) {
            return;
        }

        // If is not the current conversationSid, omit
        if (item.key !== conversationSid) {
            return;
        }

        dispatch(updateSyncMapItemData(item.data));
    });

    map.addListenerWithReplay(itemRemovedEvent, ({ key, isLocal }: SyncMapItemRemovedEvent) => {
        // Do nothing with local events
        if (isLocal) {
            return;
        }

        // If is not the current conversationSid, omit
        if (key !== conversationSid) {
            return;
        }

        // Dispatch that that syncMapItemData is undefined now
        dispatch(updateSyncMapItemData(undefined));
    });
};
